
export const baseURL = "https://hd-api-dev.developmentsites.xyz/api/";
export const imageURL = "https://hd-api-dev.developmentsites.xyz/storage";
export const secretKey = "ENTER_YOUR_KEY";
export const projectName = "Hdcutz";
